import jfetch from '@jontetz/jfetch';

export function postSendWishlistCSVEmail(data) {
    return jfetch.post('/api/wishlist/sendcsv', data);
}